module.exports = __webpack_public_path__ + "assets/img/travel-day11.715073b9.png";